import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const ProfileTranslations = wrapTranslationsSchema({
	name: 'ProfileTranslations',
	title: 'Profile Translations',
	sanityId: 'profile',
	fields: {
		pageTitle: 'Profile',
		snowSectionTitle: 'SNOW',
		aribaSectionTitle: 'Ariba',
		supplierDbSectionTitle: 'TET levels',
		id: 'ID',
		manager: 'Manager',
		location: 'Location',
		email: 'Email',
		companyCode: 'Company Code',
		purchasingOrg: 'Purchasing Org',
		requestorRoles: 'Requestor Roles',
		localeIdUniqueName: 'Locale ID Unique Name',
		sapBillingAddress: 'SAP Billing Address',
		sapPlant: 'SAP Plant',
		purchasingUnit: 'Purchasing Unit',
		countryCode: 'Country Code',
		vanillaDeliverTo: 'Vanilla Deliver To',
		sapCostCenter: 'SAP Cost Center',
		tetId0: 'TET ID 0',
		tetId1: 'TET ID 1',
		tetId2: 'TET ID 2',
		tetId3: 'TET ID 3',
		tetId4: 'TET ID 4',
	},
});
